import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/green-logo.svg';

const Navigation = () => {
  const location = useLocation();

  return (
    <nav>
      <div className="nav-container">
        <Link to="/" className="logo">
          <img src={logo} alt="Greenbucks Logo" style={{ height: '50px', width: 'auto' }} />
        </Link>
        <ul className="nav-links">
          <li><Link to="/" className={location.pathname === '/' ? 'active' : ''}>Home</Link></li>
          <li><Link to="/about" className={location.pathname === '/about' ? 'active' : ''}>About</Link></li>
          <li><Link to="/portfolio" className={location.pathname === '/portfolio' ? 'active' : ''}>Portfolio</Link></li>
          <li><Link to="/jobs" className={location.pathname === '/jobs' ? 'active' : ''}>Jobs</Link></li>
          <li><Link to="/articles" className={location.pathname === '/articles' ? 'active' : ''}>Articles</Link></li>
        </ul>
        <Link to="/jobs" className="cta-btn">Join Our Team</Link>
      </div>
    </nav>
  );
};

export default Navigation;
